/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:30
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Inquiry {
    /**
    * 获取询价列表
    */
    export var getList = (query: any): Promise<any> => {
        return Get(`/msls/Inquiry/getList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取询价详情
    */
    export var GetDetail = (InquiryId: string): Promise<any> => {
        return Get(`/msls/Inquiry/GetDetail/${InquiryId}`, {});
    };
    /**
     * 编辑
     */
    export var EditInquiry = (id: string, body: any): Promise<any> => {
        return Put(`/msls/Inquiry/Edit/${id}`, body);
    };
    /**
    * 删除
    */
    export var DelInquiry = (id: string): Promise<any> => {
        return Delete(`/msls/Inquiry/Delete/${id}`, {});
    };
    /**
     * 终结
     */
    export var EndInquiry = (id: string): Promise<any> => {
        return Put(`/msls/Inquiry/End/${id}`, {});
    };


    /**
   * 新增
   */
    export var AddInquiry = (body: any): Promise<any> => {
        return Post(`/msls/Inquiry/AddInquiry`, body);
    };

    /**
    * 获取跟踪记录
    */
    export var GetTracks = (id): Promise<any> => {
        return Get(`/msls/Inquiry/GetTracks/${id}`, {});
    };

    /**
 * 获取字典数据
 */
    export var GetDicDetailList = (query: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetDicDetailList?${qs.stringify(query)}`, {});
    };

    /**
* 定向询价调整承运商
*/
    export var UpdateCarriers = (body: any): Promise<any> => {
        return Post(`/msls/Inquiry/UpdateCarriers`, body);
    };

    /**
    * 一键否决所有报价
    */
    export var RejectAllQuote = (id: string): Promise<any> => {
        return Put(`/msls/Inquiry/RejectAllQuote/${id}`, {});
    };


    /**
* 中标
*/
    export var Win = (body: any): Promise<any> => {
        return Post(`/msls/Inquiry/Win`, body);
    };
    /**
* 取消中标
*/
    export var CancelWin = (body: any): Promise<any> => {
        return Post(`/msls/Inquiry/CancelWin`, body);
    };

    /**
* 退回报价，让承运商重新报价
*/
    export var BackQuote = (body: any): Promise<any> => {
        return Post(`/msls/Inquiry/BackQuote`, body);
    };

    /**
      * 一键催报
      */
    export var Urge = (id: string): Promise<any> => {
        return Post(`/msls/Inquiry/Urge/${id}`, {});
    };

    /**
 * 导出
 */
    export var Export = (query: any): Promise<any> => {
        return Download(`/msls/Inquiry/Export?${qs.stringify(query)}`, {});
    };

    export var GetContacters = (query: any): Promise<any> => {
        return Get(`/msls/Inquiry/GetContacters?${qs.stringify(query)}`, {});
    };

    // 订单导入
    export var GetGoodsTemplate = (data): Promise<any> => {
        return Download(`/msls/Inquiry/ExportGoodsTemplate?${qs.stringify(data)}`, '');
    };

    export var uploadGoodsExcel = (data): Promise<any> => {
        return Post(`/msls/Inquiry/ImportGoods`, data);
    };

    export var AddNegotiateQuote = (data): Promise<any> => {
        return Post(`/msls/Inquiry/AddNegotiateQuote`, data);
    };
}
